import { Link } from 'react-router-dom'
import { Home } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { usePageTitle, setDocumentTitle } from '../utils/translation'

export default function Terms() {
  const { t } = useTranslation()
  const pageTitle = usePageTitle('pages.terms.title', 'Terms of Service')
  
  useEffect(() => {
    setDocumentTitle(pageTitle)
  }, [pageTitle])

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white shadow-sm">
        <div className="flex items-center px-4 py-4">
          <Link 
            to="/" 
            className="w-10 h-10 flex items-center justify-center rounded-full bg-amber-600 mr-4 shadow-sm hover:bg-amber-700 transition-colors"
            aria-label="Return to home"
          >
            <Home size={20} className="text-white" />
          </Link>
          <h1 className="font-bold text-xl text-amber-800">{t('pages.terms.title')}</h1>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-5 py-8">
        <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
          <h2 className="text-xl font-bold text-amber-900 mb-4">{t('pages.terms.piika_terms')}</h2>
          <p className="text-amber-800 mb-4">
            {t('pages.terms.last_updated')}
          </p>
          
          <section className="mb-6">
            <h3 className="text-lg font-semibold text-amber-900 mb-2">{t('pages.terms.sections.acceptance.title')}</h3>
            <p className="text-amber-800 mb-3">
              {t('pages.terms.sections.acceptance.content')}
            </p>
          </section>
          
          <section className="mb-6">
            <h3 className="text-lg font-semibold text-amber-900 mb-2">{t('pages.terms.sections.use_of_services.title')}</h3>
            <p className="text-amber-800 mb-3">
              {t('pages.terms.sections.use_of_services.content')}
            </p>
          </section>
          
          <section className="mb-6">
            <h3 className="text-lg font-semibold text-amber-900 mb-2">{t('pages.terms.sections.subscription.title')}</h3>
            <p className="text-amber-800 mb-3">
              {t('pages.terms.sections.subscription.content')}
            </p>
            <p className="text-amber-800 mb-3">
              {t('pages.terms.sections.subscription.billing')}
            </p>
            <p className="text-amber-800 mb-3">
              {t('pages.terms.sections.subscription.cancellation')}
            </p>
          </section>
          
          <section className="mb-6">
            <h3 className="text-lg font-semibold text-amber-900 mb-2">{t('pages.terms.sections.delivery.title')}</h3>
            <p className="text-amber-800 mb-3">
              {t('pages.terms.sections.delivery.service_area')}
            </p>
            <p className="text-amber-800 mb-3">
              {t('pages.terms.sections.delivery.schedule')}
            </p>
            <p className="text-amber-800 mb-3">
              {t('pages.terms.sections.delivery.missed')}
            </p>
          </section>
          
          <section className="mb-6">
            <h3 className="text-lg font-semibold text-amber-900 mb-2">{t('pages.terms.sections.product_availability.title')}</h3>
            <p className="text-amber-800 mb-3">
              {t('pages.terms.sections.product_availability.content')}
            </p>
          </section>
          
          <section className="mb-6">
            <h3 className="text-lg font-semibold text-amber-900 mb-2">{t('pages.terms.sections.account_security.title')}</h3>
            <p className="text-amber-800 mb-3">
              {t('pages.terms.sections.account_security.content')}
            </p>
          </section>
          
          <section className="mb-6">
            <h3 className="text-lg font-semibold text-amber-900 mb-2">{t('pages.terms.sections.liability.title')}</h3>
            <p className="text-amber-800 mb-3">
              {t('pages.terms.sections.liability.content')}
            </p>
          </section>
          
          <section className="mb-6">
            <h3 className="text-lg font-semibold text-amber-900 mb-2">{t('pages.terms.sections.changes.title')}</h3>
            <p className="text-amber-800 mb-3">
              {t('pages.terms.sections.changes.content')}
            </p>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-amber-900 mb-2">{t('pages.terms.sections.contact.title')}</h3>
            <p className="text-amber-800">
              {t('pages.terms.sections.contact.content')}
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white py-6 px-5 border-t border-amber-100">
        <div className="flex flex-col items-center space-y-4">
          <p className="text-center text-xs text-amber-600">
            &copy; {new Date().getFullYear()} {t('pages.terms.footer.copyright')}
          </p>
          <div className="flex space-x-4">
            <a href="/terms" className="text-xs text-amber-700 font-bold">{t('pages.terms.footer.terms')}</a>
            <a href="/privacy" className="text-xs text-amber-700">{t('pages.terms.footer.privacy')}</a>
            <a href="/contact" className="text-xs text-amber-700">{t('pages.terms.footer.contact')}</a>
          </div>
        </div>
      </footer>
    </div>
  )
} 